
<div class="panel">
  <h2>Table de capitalisation</h2>

  <div class="form-group">
    <label>Nombre de titres</label>
    <span class="value">{{ capitalisation.total | slshare }}</span>
  </div>

  <div class="form-group">
    <label>Capital social (€)</label>
    <span class="value">{{ capitalisation.capital | slshare | empty }}</span>
  </div>

  <table>
    <thead class="group">
      <tr>
        <th>Titulaire</th>
        <th>Courrier électronique</th>
        <th>Adresse</th>
        <th class="text-center">Nombre d'actions ordinaires (PP + NP)</th>
        <th class="text-center" *ngIf="showColumn_PP_NP_AT_PREF">
          Nombre d'actions de préférence (PP + NP)
        </th>
        <th class="text-center">% de détention du capital</th>
        <th class="text-center" *ngIf="showColumn_UF_ORD">
          Nombre d'actions ordinaires (UF)
        </th>
        <th class="text-center" *ngIf="showColumn_UF_PREF">
          Nombre d'actions de préférence (UF)
        </th>
      </tr>
    </thead>
    <tbody>
      <!-- Items -->
      <tr *ngFor="let ci of capitalisation.items">
        <td>{{ ci.account.name }}</td>
        <td>{{ ci.account.email }}</td>
        <td>{{ ci.account.address | sladdress:', ' }}</td>
        <td class="text-center">
          {{ ci.PP_NP_AT_ORD | slshare }}
        </td>
        <td class="text-center" *ngIf="showColumn_PP_NP_AT_PREF">
          {{ ci.PP_NP_AT_PREF | slshare }}
        </td>
        <td class="text-center">
          {{ (ci.percent * 100).toFixed(2) }} %
        </td>
        <td class="text-center" *ngIf="showColumn_UF_ORD">
          {{ ci.UF_ORD | slshare }}
        </td>
        <td class="text-center" *ngIf="showColumn_UF_PREF">
          {{ ci.UF_PREF | slshare }}
        </td>
      </tr>

      <!-- subTotal -->
      <tr>
        <th class="text-right" [attr.colspan]="3">
          Total
        </th>
        <th class="text-center">
          {{ capitalisation.PP_NP_AT_ORD | slshare }}
        </th>
        <th class="text-center" *ngIf="showColumn_PP_NP_AT_PREF">
          {{ capitalisation.PP_NP_AT_PREF | slshare }}
        </th>
        <th class="text-center">
          100 %
        </th>
        <th class="text-center" *ngIf="showColumn_UF_ORD">
          {{ capitalisation.UF_ORD | slshare }}
        </th>
        <th class="text-center" *ngIf="showColumn_UF_PREF">
          {{ capitalisation.UF_PREF | slshare }}
        </th>
      </tr>

      <!-- total -->
      <tr>
        <th class="text-right" [attr.colspan]="3">
          Total général
        </th>
        <th class="text-center" [attr.colspan]="showColumn_PP_NP_AT_PREF ? 2 : 1">
          {{ capitalisation.total | slshare }}
        </th>
        <th></th>
        <th *ngIf="showColumn_UF_ORD"></th>
        <th *ngIf="showColumn_UF_PREF"></th>
      </tr>

    </tbody>
  </table>
</div>

<div class="panel">
  <h2>Liste des mouvements</h2>

  <table>
    <thead class="group">
      <tr>
        <th style="width: 100px;" rowspan="2">Date</th>
        <th style="width: 80px;" rowspan="2">Numéro d'ordre</th>
        <th colspan="4" class="text-center border-left">Au débit de</th>
        <th colspan="4" class="text-center border-left">Au crédit de</th>
        <th rowspan="2" class="border-left">Observations</th>
      </tr>
      <tr>
        <th class="border-left" style="width: 100px;">Numéro du compte</th>
        <th>Titulaire</th>
        <th>Nombre et Nature de titres</th>
        <th>Nature du mouvement</th>

        <th class="border-left" style="width: 100px;">Numéro du compte</th>
        <th>Titulaire</th>
        <th>Nombre et Nature de titres</th>
        <th>Nature du mouvement</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let movement of movements; index as mi">
        <tr *ngFor="let line of movement.lines; index as i" class="group" ngClass="{{ mi % 2 ? '' : 'group-even' }}">
          <td style="width: 100px;" name="Date" [attr.rowspan]="movement.lines.length" *ngIf="i == 0">{{ movement.writingDate | movementwritingdate }}</td>
          <td style="width: 80px;" name="Numéro d'ordre" [attr.rowspan]="movement.lines.length" *ngIf="i == 0">{{ movement.no }}</td>

          <td name="Au débit de / Numéro du compte" class="border-left" style="width: 100px;">{{ line.debit?.account.no }}</td>
          <td name="Au débit de / Titulaire">{{ line.debit?.account.name }}</td>
          <td name="Au débit de / Nombre et Nature de titres">{{ line.debit?.amount | slshare }} {{ line.debit?.ownership }} {{ line.debit?.shareType | slmovementlinesharetype:'short' }} <span *ngIf="line.debit?.isHidden" class="is-hidden">[Masquée]</span></td>
          <td name="Au débit de / Nature du mouvement">{{ line.debit?.nature | slmovementlinenature }}</td>
          
          <td name="Au crédit de / Numéro du compte" class="border-left" style="width: 100px;">{{ line.credit?.account.no }}</td>
          <td name="Au crédit de / Titulaire">{{ line.credit?.account.name }}</td>
          <td name="Au crédit de / Nombre et Nature de titres">{{ line.credit?.amount | slshare }} {{ line.credit?.ownership }} {{ line.credit?.shareType | slmovementlinesharetype:'short' }} <span *ngIf="line.credit?.isHidden" class="is-hidden">[Masquée]</span></td>
          <td name="Au débit de / Nature du mouvement">{{ line.credit?.nature | slmovementlinenature }}</td>
          
          <td name="Observations" [attr.rowspan]="movement.lines.length" *ngIf="i == 0" class="border-left">{{ movement.description }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>


    
<div class="panel">
  <h2>Liste des comptes d’actionnaires</h2>

  <table>
    <thead>
      <tr>
        <th style="width: 30px;" rowspan="2">Numéro</th>
        <th rowspan="2">Titulaire</th>
        
        <th rowspan="2" class="text-center border-left">PP</th>
        <th rowspan="2" class="text-center border-left">UF</th>
        <th rowspan="2" class="text-center border-left">NP</th>

        <th colspan="2" class="text-center border-left">Total</th>
      </tr>

      <tr>
        <th class="text-center border-left">PP</th>
        <th class="text-center">UF + NP</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let account of accounts">
        <td style="width: 30px;" name="Numéro">{{ account.no }}</td>
        <td name="Titulaire">{{ account.name }}</td>
        
        <td class="text-center border-left" name="PP" [innerHTML]="account.balance.items | slaccountbalanceitems:'PP'"></td>

        <td class="text-center border-left" name="UF" [innerHTML]="account.balance.items | slaccountbalanceitems:'UF'"></td>

        <td class="text-center border-left" name="NP" [innerHTML]="account.balance.items | slaccountbalanceitems:'NP'"></td>

        <td class="text-center border-left" name="PP">{{ account.balance.PP | slshare }}</td>
        <td class="text-center" name="UF + NP">{{ account.balance.UF_NP_AT | slshare }}</td>

      </tr>

      <!-- Total -->
      <tr>
        <th colspan="2" name="Total">Total</th>
        
        <th class="text-center border-left" name="PP">{{ totalBalance.PP | slshare }}</th>
        <th class="text-center" name="UF">{{ totalBalance.UF | slshare }}</th>
        <th class="text-center" name="NP">{{ totalBalance.NP | slshare }}</th>

        <th class="text-center border-left" colspan="2" name="Total">{{ totalBalance.total | slshare }}</th>

      </tr>

    </tbody>
  </table>

</div>


<div *ngFor="let account of accounts" class="panel">
  <h2>Compte d'actionnaire n° {{ account.no }}</h2>

  <div class="form-group">
    <label>Nom et prénom ou Dénomination</label>
    <span class="value">{{ account.name }}</span>
  </div>

  <div class="form-group" *ngIf="account.type === 'COMPANY'">
    <label>Numéro de RCS</label>
    <span class="value">{{ account.rcs | empty }}</span>
  </div>

  <div class="form-group">
    <label>Adresse</label>
    <span class="value" style="white-space: pre-line;">{{ account.address | sladdress }}</span>
  </div>

  <div class="form-group">
    <label>Courrier électronique</label>
    <span class="value">{{ account.email | empty }}</span>
  </div>

  <div class="form-group">
    <label>Téléphone</label>
    <span class="value">{{ account.phone | empty }}</span>
  </div>

  <table>
    <thead class="group">
      <tr>
        <th style="width: 80px;" rowspan="2">Numéro d'ordre</th>
        <th colspan="2" class="text-center border-left">Opération</th>
        <th colspan="3" class="text-center border-left">Nombre et nature des titres</th>
        <th rowspan="2" class="border-left">Observations</th>
      </tr>
      <tr>
        <th style="width: 100px;" class="border-left">Date</th>
        <th>Nature du mouvement</th>
        
        <th class="border-left">Au débit</th>
        <th>Au crédit</th>

        <th>Solde</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let movement of account.movements; index as mi">
        <tr *ngFor="let line of movement.lines; index as i" class="group" ngClass="{{ mi % 2 ? '' : 'group-even' }}">
          <td style="width: 80px;" name="Numéro d'ordre" [attr.rowspan]="movement.lines.length" *ngIf="i == 0">{{ movement.no }}</td>
          <td style="width: 100px;" class="border-left" name="Date" [attr.rowspan]="movement.lines.length" *ngIf="i == 0">{{ movement.writingDate | movementwritingdate }}</td>
          
          <td name="Nature du mouvement">
            <ng-container *ngFor="let nature of line.natures">{{ nature | slmovementlinenature }}</ng-container>
          </td>
          
          <td name="Au débit" class="border-left">{{ line.debit?.amount | slshare }} {{ line.debit?.ownership }} {{ line.debit?.shareType | slmovementlinesharetype:'short' }} <span *ngIf="line.debit?.isHidden" class="is-hidden">[Masquée]</span></td>
          
          <td name="Au crédit">{{ line.credit?.amount | slshare }} {{ line.credit?.ownership }} {{ line.credit?.shareType | slmovementlinesharetype:'short' }} <span *ngIf="line.credit?.isHidden" class="is-hidden">[Masquée]</span></td>

          <td name="Solde" *ngIf="i == 0" [attr.rowspan]="movement.lines.length">
            <ng-container *ngFor="let b of movement.balances; index as idx">
              {{ b.amount | slshare }} {{ b.ownership }} {{ b.shareType | slmovementlinesharetype:'short' }} <br *ngIf="idx < movement.balances.length - 1"/>
            </ng-container>
          </td>
          
          <td name="Observations" [attr.rowspan]="movement.lines.length" *ngIf="i == 0" class="border-left">{{ movement.description }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

</div>